export default "__VITE_ASSET__DNEEizT6__"